"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _IndexProvider = _interopRequireWildcard(require("./IndexProvider"));
var _TableRowContext = _interopRequireDefault(require("./TableRowContext"));
var _classes = require("./classes");
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "borderTop", "borderBottom", "label"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var styles = function styles(theme) {
  return {
    root: {
      // background: theme.palette.background.paper,
      '&:last-child td': {
        border: 0
      }
    }
  };
};
var _i = 0;
var TableRow = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    _ref$borderTop = _ref.borderTop,
    borderTop = _ref$borderTop === void 0 ? false : _ref$borderTop,
    _ref$borderBottom = _ref.borderBottom,
    borderBottom = _ref$borderBottom === void 0 ? false : _ref$borderBottom,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(function () {
      return "table-row-".concat(_i++);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var index = (0, _IndexProvider.useRegisterIndex)(id);
  var getDataCy = function getDataCy() {
    return {
      'data-cy': 'TableRow',
      'data-cy-index': index,
      'data-cy-label': label
      // 'data-cy-id': id,
      // ...((data.label || data['data-cy-label']) && {
      //   'data-cy-label': data.label || data['data-cy-label'],
      // }),
    };
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IndexProvider["default"], {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRowContext["default"].Provider, {
      value: {
        borderTop: borderTop,
        borderBottom: borderBottom
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRow["default"], _objectSpread(_objectSpread({}, props), {}, {
        ref: ref,
        id: id,
        className: (0, _clsx["default"])(className, _classes.STICKY_TABLE_ROW)
      }, getDataCy()))
    })
  });
});
TableRow.propTypes = {
  className: _propTypes["default"].string,
  /**
   * Should be valid <tr> children such as TableCell
   */
  children: _propTypes["default"].node,
  /**
   *	Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * 	The component used for the root node. Either a string to use a HTML element or a component.
   */
  component: _propTypes["default"].elementType,
  /**
   * If true, the table row will shade on hover.
   */
  hover: _propTypes["default"].bool,
  /**
   * 	If true, the table row will have the selected shading.
   */
  selected: _propTypes["default"].bool,
  borderTop: _propTypes["default"].bool,
  borderBottom: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'GgTableRow'
})(TableRow);